'use strict';

var styled = require('styled-components');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var styled__default = /*#__PURE__*/_interopDefaultCompat(styled);

const CellStyled = styled__default.default.td `
  padding-block: ${({ theme, $noVerticalPadding }) => ($noVerticalPadding ? 0 : theme.designTokens.tableCellPadding)};
  padding-inline: ${({ theme }) => theme.designTokens.tableCellPadding};
  font-size: ${({ theme }) => theme.typography.fontSize.xs};
  font-weight: ${({ $important }) => ($important ? '500' : '400')};
  line-height: 1.5rem;
  color: ${({ theme }) => theme.colors.body.text};
  vertical-align: middle;
  overflow: hidden;
  &:first-child {
    padding-left: ${({ theme }) => theme.designTokens.tableFirstColumCellPaddingLeft};
  }
`;
const CellContentStyled = styled__default.default.div `
  ${({ $noEllipsis }) => $noEllipsis
    ? `
          display: flex;
          align-items: center;
          justify-content: start;
        `
    : `
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
        `}
`;

exports.CellContentStyled = CellContentStyled;
exports.CellStyled = CellStyled;
//# sourceMappingURL=cell.styles.js.map
